module.exports = __webpack_public_path__ + "img/vip_icon.0fd2372f.png";